import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PanoramaVerticalSelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"panorama_vertical_select"}/>
}
